const styles = {
  root: { paddingX: 2, paddingTop: 2, minHeight: 60 },
}
export default styles
